import loadable from '@loadable/component';

export default loadable(() => import('./Modal'));
export type { ModalProps } from './Modal';
